<ng-template #settingsTemplate>
    <app-tool-setting>
        <app-check-box
            [checked]="showPercentages"
            (checkedChange)="toggleshowPercentages()"
            label="procenten"
        ></app-check-box>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 526.17 114.29"
        style="width: 690px"
    >
        <defs>
            <style>
                .percentStrip-white {
                    fill: #fff;
                }
                .strip-hide-strip {
                    fill: transparent !important;
                }
                .percentStrip-1 {
                    fill: #d4e8f6;
                }
                .percentStrip-2 {
                    fill: #494949;
                }
                .percentStrip-3 {
                    fill: none;
                    stroke: #0091d5;
                    stroke-width: 1.5px;
                }
                .percentStrip-4 {
                    fill: transparent;
                }
                .cursor-hand {
                    cursor: pointer;
                }
            </style>
        </defs>
        <title>ATQ_DBS_procentenstrook</title>
        <g id="white_bg" data-name="white bg">
            <polygon
                class="percentStrip-white"
                points="8.47 0.75 8.47 95.25 506.97 95.25 506.97 0.75 63.67 0.75 8.47 0.75"
            />
        </g>
        <g
            id="filling"
            class="cursor-hand"
            (mousedown)="isMouseDown$.next(true)"
            (mouseup)="isMouseDown$.next(false)"
            (mouseenter)="isMouseOver$.next(true)"
            (mouseleave)="isMouseOver$.next(false); isMouseDown$.next(false)"
        >
            <rect
                class="percentStrip-4"
                x="3.8"
                y="0.32"
                width="5"
                height="95.42"
                (mouseover)="mouseMove$.next(-1)"
            />
            @for (strip of strips; track stripTracker($index); let index = $index) {
            <rect
                class="percentStrip-1"
                width="5"
                height="95.42"
                [ngClass]="{'hide-strip': strip.hidden}"
                [attr.x]="strip.x"
                y="0.32"
                (mouseover)="mouseMove$.next(index)"
            />
            }
        </g>
        <g id="Laag_1" data-name="Laag 1">
            @if (showPercentages) {
            <g class="percent-strip-numbers">
                <path
                    class="percentStrip-2"
                    d="M62,104.59a13.64,13.64,0,0,1-2.58,1.6v-1.6a16.11,16.11,0,0,0,2.69-1.74H63.5v11.07H62Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M70.08,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.52,4.09-1.53,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C66.37,106.86,66.56,102.62,70.08,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.55-2.2,4.53C67.9,110.9,68.38,112.82,70.06,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M80.59,105.37c0,2-1.17,2.9-2.62,2.9a2.47,2.47,0,0,1-2.58-2.8,2.62,2.62,0,0,1,2.72-2.93C80,102.54,80.59,103.92,80.59,105.37Zm-1.26.07c0-.79-.19-1.94-1.33-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S79.33,105.76,79.33,105.44Zm-1.81,9.11,7.06-12.33h1l-7,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2,0-2.62-1.52-2.62-2.85a2.67,2.67,0,0,1,4.54-2.11Zm-.56,2.07c0-.5-.09-1.94-1.34-1.94S84,110.94,84,111.42s.13,1.75,1.35,1.75S86.72,111.79,86.72,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M18.59,102.62c3.31,0,3.72,3.55,3.72,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C14.88,106.86,15.07,102.62,18.59,102.62Zm0,10.2c1.85,0,2.17-2.44,2.17-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.55-2.2,4.53C16.41,110.9,16.9,112.82,18.58,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M29.1,105.37c0,2-1.16,2.9-2.62,2.9a2.48,2.48,0,0,1-2.58-2.8,2.62,2.62,0,0,1,2.72-2.93C28.46,102.54,29.1,103.92,29.1,105.37Zm-1.26.07c0-.79-.19-1.94-1.33-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S27.84,105.76,27.84,105.44ZM26,114.55l7.06-12.33h1.06l-7.06,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2,0-2.62-1.52-2.62-2.85a2.58,2.58,0,0,1,2.62-2.88A2.54,2.54,0,0,1,35.79,109.15Zm-.56,2.07c0-.5-.09-1.94-1.34-1.94s-1.38,1.66-1.38,2.14.13,1.75,1.35,1.75S35.23,111.79,35.23,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M108.35,112.46l2.9-2.84a17.05,17.05,0,0,0,1.71-1.91,3.16,3.16,0,0,0,.82-2,1.67,1.67,0,0,0-1.78-1.81,1.71,1.71,0,0,0-1.81,1.94h-1.68a3.12,3.12,0,0,1,1-2.43,3.63,3.63,0,0,1,2.41-.8c1.69,0,3.42.86,3.42,3.23,0,.71,0,1.25-1.25,2.77-.32.4-1.73,1.86-2,2.18l-1.93,1.84h5.26v1.26h-7Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M120.82,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C117.1,106.86,117.29,102.62,120.82,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.93,0-2.19,2.55-2.19,4.53C118.64,110.9,119.12,112.82,120.8,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M131.33,105.37c0,2-1.17,2.9-2.63,2.9a2.47,2.47,0,0,1-2.57-2.8,2.62,2.62,0,0,1,2.72-2.93C130.69,102.54,131.33,103.92,131.33,105.37Zm-1.27.07c0-.79-.19-1.94-1.32-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S130.06,105.76,130.06,105.44Zm-1.8,9.11,7.05-12.33h1.06l-7.06,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2,0-2.63-1.52-2.63-2.85a2.58,2.58,0,0,1,2.63-2.88A2.55,2.55,0,0,1,138,109.15Zm-.56,2.07c0-.5-.1-1.94-1.35-1.94s-1.37,1.66-1.37,2.14.13,1.75,1.34,1.75S137.46,111.79,137.46,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M159.61,111.07c0,1.06.68,1.81,2,1.81a2,2,0,0,0,2.21-2,1.92,1.92,0,0,0-1.6-2,6.18,6.18,0,0,0-1.54-.08v-1.3c1.1.1,3-.12,3-1.92,0-1.25-.85-1.74-2-1.74a1.86,1.86,0,0,0-2,1.74h-1.62c.1-2.75,2.69-3,3.59-3,2.42,0,3.62,1.45,3.62,3a2.63,2.63,0,0,1-2.21,2.61,2.61,2.61,0,0,1,2.37,2.69c0,1.55-1.27,3.26-3.84,3.26a4,4,0,0,1-3.05-1.15,2.87,2.87,0,0,1-.65-2Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M170.62,102.62c3.32,0,3.72,3.55,3.72,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C166.91,106.86,167.1,102.62,170.62,102.62Zm0,10.2c1.85,0,2.17-2.44,2.17-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.19,2.55-2.19,4.53C168.45,110.9,168.93,112.82,170.61,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M181.14,105.37c0,2-1.17,2.9-2.63,2.9a2.48,2.48,0,0,1-2.58-2.8,2.63,2.63,0,0,1,2.72-2.93C180.5,102.54,181.14,103.92,181.14,105.37Zm-1.27.07c0-.79-.19-1.94-1.33-1.94-1.37,0-1.37,1.57-1.37,2s0,1.89,1.37,1.89S179.87,105.76,179.87,105.44Zm-1.81,9.11,7.06-12.33h1.06l-7.06,12.33Zm9.77-5.4a2.75,2.75,0,0,1,.65,2c0,1.75-.85,2.93-2.57,2.93-2,0-2.63-1.52-2.63-2.85a2.68,2.68,0,0,1,4.55-2.11Zm-.56,2.07c0-.5-.1-1.94-1.35-1.94s-1.37,1.66-1.37,2.14.12,1.75,1.34,1.75S187.27,111.79,187.27,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M212.14,111.52h-5v-1.9l4.8-6.92h1.73v7.52h1.62v1.3h-1.62v2.4h-1.54Zm.05-1.3v-5.84l-3.82,5.84Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M220,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C216.3,106.86,216.49,102.62,220,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.94,0-2.19,2.55-2.19,4.53C217.84,110.9,218.32,112.82,220,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M230.53,105.37c0,2-1.17,2.9-2.63,2.9a2.47,2.47,0,0,1-2.57-2.8,2.62,2.62,0,0,1,2.72-2.93C229.89,102.54,230.53,103.92,230.53,105.37Zm-1.27.07c0-.79-.19-1.94-1.32-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S229.26,105.76,229.26,105.44Zm-1.8,9.11,7-12.33h1.06l-7.06,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2.05,0-2.63-1.52-2.63-2.85a2.68,2.68,0,0,1,4.55-2.11Zm-.56,2.07c0-.5-.1-1.94-1.35-1.94s-1.37,1.66-1.37,2.14.13,1.75,1.34,1.75S236.66,111.79,236.66,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M260.69,111.3a1.68,1.68,0,0,0,1.84,1.57,2.28,2.28,0,0,0,2.19-2.55c0-1.5-.82-2.38-2.1-2.38a2.07,2.07,0,0,0-1.48.57,2,2,0,0,0-.52.93h-1.45l.28-6.59h6.23v1.29h-4.85l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.23,0,3.31,1.75,3.31,3.65a3.71,3.71,0,0,1-3.95,3.83,3,3,0,0,1-3.3-2.88Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M271.44,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.53,4.09-1.53,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C267.73,106.86,267.92,102.62,271.44,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.55-2.2,4.53C269.26,110.9,269.74,112.82,271.42,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M282,105.37c0,2-1.17,2.9-2.62,2.9a2.47,2.47,0,0,1-2.58-2.8,2.62,2.62,0,0,1,2.72-2.93C281.31,102.54,282,103.92,282,105.37Zm-1.26.07c0-.79-.19-1.94-1.33-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S280.69,105.76,280.69,105.44Zm-1.81,9.11,7.06-12.33H287l-7.05,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2.05,0-2.62-1.52-2.62-2.85a2.67,2.67,0,0,1,4.54-2.11Zm-.56,2.07c0-.5-.09-1.94-1.34-1.94s-1.38,1.66-1.38,2.14.13,1.75,1.35,1.75S288.08,111.79,288.08,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M311.5,105.47a1.55,1.55,0,0,0-1.68-1.65c-1.6,0-2.3,1.38-2.45,4.32a2.82,2.82,0,0,1,2.58-1.4,3.25,3.25,0,0,1,3.35,3.55,3.64,3.64,0,0,1-3.75,3.87,3.5,3.5,0,0,1-2.74-1.2,7,7,0,0,1-1-4.08c0-2.42.59-6.26,4.09-6.26a3.45,3.45,0,0,1,2.66,1.06,2.64,2.64,0,0,1,.59,1.79Zm.26,5c0-.78-.22-2.46-2.06-2.46a2.51,2.51,0,0,0-.08,5A2.22,2.22,0,0,0,311.76,110.43Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M318.3,102.62c3.32,0,3.72,3.55,3.72,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C314.59,106.86,314.78,102.62,318.3,102.62Zm0,10.2c1.85,0,2.17-2.44,2.17-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.19,2.55-2.19,4.53C316.13,110.9,316.61,112.82,318.29,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M328.82,105.37c0,2-1.17,2.9-2.63,2.9a2.48,2.48,0,0,1-2.58-2.8,2.63,2.63,0,0,1,2.72-2.93C328.18,102.54,328.82,103.92,328.82,105.37Zm-1.27.07c0-.79-.19-1.94-1.33-1.94-1.37,0-1.37,1.57-1.37,2s0,1.89,1.37,1.89S327.55,105.76,327.55,105.44Zm-1.81,9.11,7.06-12.33h1.06l-7.06,12.33Zm9.77-5.4a2.75,2.75,0,0,1,.65,2c0,1.75-.85,2.93-2.57,2.93-2,0-2.63-1.52-2.63-2.85a2.68,2.68,0,0,1,4.55-2.11Zm-.56,2.07c0-.5-.1-1.94-1.35-1.94s-1.37,1.66-1.37,2.14.12,1.75,1.34,1.75S335,111.79,335,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M357.6,102.85h7.31v1.34l-4.06,9.73H359l4.26-9.75h-5.7Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M370.35,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.52,4.09-1.53,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C366.64,106.86,366.83,102.62,370.35,102.62Zm0,10.2c1.85,0,2.17-2.44,2.17-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.55-2.2,4.53C368.17,110.9,368.65,112.82,370.34,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M380.86,105.37c0,2-1.16,2.9-2.62,2.9a2.48,2.48,0,0,1-2.58-2.8,2.62,2.62,0,0,1,2.72-2.93C380.22,102.54,380.86,103.92,380.86,105.37Zm-1.26.07c0-.79-.19-1.94-1.33-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S379.6,105.76,379.6,105.44Zm-1.81,9.11,7.06-12.33h1.06l-7.06,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2.05,0-2.62-1.52-2.62-2.85a2.58,2.58,0,0,1,2.62-2.88A2.54,2.54,0,0,1,387.55,109.15Zm-.56,2.07c0-.5-.09-1.94-1.34-1.94s-1.38,1.66-1.38,2.14.13,1.75,1.35,1.75S387,111.79,387,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M406.21,105.61c0-1,.67-3,3.58-3,2.34,0,3.68,1.26,3.68,3a2.54,2.54,0,0,1-2.25,2.51,2.81,2.81,0,0,1,2.41,2.8c0,1.52-1.05,3.25-3.81,3.25a4.21,4.21,0,0,1-2.86-.92,3.12,3.12,0,0,1-1-2.23,2.81,2.81,0,0,1,.85-2,3.53,3.53,0,0,1,1.6-.85A2.56,2.56,0,0,1,406.21,105.61Zm3.61,7.24a2.06,2.06,0,1,0,0-4.11,2.1,2.1,0,0,0-2.26,2.08A2,2,0,0,0,409.82,112.85Zm0-9.08a1.89,1.89,0,0,0-2.1,1.81,1.87,1.87,0,0,0,2.05,1.8,1.91,1.91,0,0,0,2.13-1.8A1.85,1.85,0,0,0,409.86,103.77Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M418.7,102.62c3.32,0,3.72,3.55,3.72,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C415,106.86,415.18,102.62,418.7,102.62Zm0,10.2c1.85,0,2.17-2.44,2.17-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.19,2.55-2.19,4.53C416.53,110.9,417,112.82,418.69,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M429.22,105.37c0,2-1.17,2.9-2.63,2.9a2.48,2.48,0,0,1-2.58-2.8,2.63,2.63,0,0,1,2.72-2.93C428.58,102.54,429.22,103.92,429.22,105.37Zm-1.27.07c0-.79-.19-1.94-1.33-1.94-1.37,0-1.37,1.57-1.37,2s0,1.89,1.37,1.89S428,105.76,428,105.44Zm-1.81,9.11,7.06-12.33h1.06l-7.06,12.33Zm9.77-5.4a2.75,2.75,0,0,1,.65,2c0,1.75-.85,2.93-2.57,2.93-2.05,0-2.63-1.52-2.63-2.85a2.68,2.68,0,0,1,4.55-2.11Zm-.56,2.07c0-.5-.1-1.94-1.35-1.94s-1.37,1.66-1.37,2.14.12,1.75,1.34,1.75S435.35,111.79,435.35,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M456.16,111.28c0,1,.53,1.63,1.78,1.63,2.43,0,2.44-2.86,2.36-4.59a2.65,2.65,0,0,1-2.48,1.39,3.27,3.27,0,0,1-3.37-3.5,3.34,3.34,0,0,1,3.55-3.57,3.52,3.52,0,0,1,3.57,2.72,10.36,10.36,0,0,1,.32,3c0,1.63,0,5.84-4.08,5.84-1.51,0-3.27-.59-3.33-2.9Zm1.84-7.44c-1.3,0-2,1.07-2,2.38a2.06,2.06,0,0,0,2.1,2.28,2,2,0,0,0,2-2.26A2.17,2.17,0,0,0,458,103.84Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M467.06,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C463.34,106.86,463.53,102.62,467.06,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.94,0-2.19,2.55-2.19,4.53C464.88,110.9,465.36,112.82,467,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M477.57,105.37c0,2-1.17,2.9-2.63,2.9a2.47,2.47,0,0,1-2.57-2.8,2.62,2.62,0,0,1,2.72-2.93C476.93,102.54,477.57,103.92,477.57,105.37Zm-1.27.07c0-.79-.19-1.94-1.33-1.94-1.37,0-1.37,1.57-1.37,2s0,1.89,1.37,1.89S476.3,105.76,476.3,105.44Zm-1.8,9.11,7.05-12.33h1.06l-7.06,12.33Zm9.76-5.4a2.7,2.7,0,0,1,.66,2c0,1.75-.85,2.93-2.58,2.93-2,0-2.63-1.52-2.63-2.85a2.68,2.68,0,0,1,4.55-2.11Zm-.56,2.07c0-.5-.1-1.94-1.35-1.94s-1.37,1.66-1.37,2.14.13,1.75,1.34,1.75S483.7,111.79,483.7,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M505.56,104.59a13.33,13.33,0,0,1-2.58,1.6v-1.6a16.11,16.11,0,0,0,2.69-1.74h1.43v11.07h-1.54Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M513.66,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.53,4.09-1.54,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C509.94,106.86,510.13,102.62,513.66,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.94,0-2.19,2.55-2.19,4.53C511.48,110.9,512,112.82,513.64,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M523.19,102.62c3.31,0,3.71,3.55,3.71,5.64,0,2.62-.52,4.09-1.53,5a3.3,3.3,0,0,1-5.17-1,8.06,8.06,0,0,1-.72-3.8C519.48,106.86,519.67,102.62,523.19,102.62Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.55-2.2,4.53C521,110.9,521.49,112.82,523.17,112.82Z"
                    transform="translate(-14.88 -0.26)"
                />
                <path
                    class="percentStrip-2"
                    d="M533.7,105.37c0,2-1.16,2.9-2.62,2.9a2.48,2.48,0,0,1-2.58-2.8,2.63,2.63,0,0,1,2.72-2.93C533.06,102.54,533.7,103.92,533.7,105.37Zm-1.26.07c0-.79-.19-1.94-1.33-1.94-1.38,0-1.38,1.57-1.38,2s0,1.89,1.38,1.89S532.44,105.76,532.44,105.44Zm-1.81,9.11,7.06-12.33h1.06l-7.06,12.33Zm9.77-5.4a2.75,2.75,0,0,1,.65,2c0,1.75-.85,2.93-2.58,2.93-2,0-2.62-1.52-2.62-2.85a2.68,2.68,0,0,1,4.55-2.11Zm-.57,2.07c0-.5-.09-1.94-1.34-1.94s-1.38,1.66-1.38,2.14.13,1.75,1.35,1.75S539.83,111.79,539.83,111.22Z"
                    transform="translate(-14.88 -0.26)"
                />
            </g>
            }
            <polygon
                class="percentStrip-3"
                points="8.47 0.75 8.47 95.25 506.97 95.25 506.97 0.75 63.67 0.75 8.47 0.75"
            />
            <line
                class="percentStrip-3"
                x1="58.32"
                y1="86"
                x2="58.32"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="158.02"
                y1="86"
                x2="158.02"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="257.72"
                y1="86"
                x2="257.72"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="357.42"
                y1="86"
                x2="357.42"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="108.17"
                y1="86"
                x2="108.17"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="207.87"
                y1="86"
                x2="207.87"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="307.57"
                y1="86"
                x2="307.57"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="407.27"
                y1="86"
                x2="407.27"
                y2="96"
            />
            <line
                class="percentStrip-3"
                x1="58.32"
                y1="0.58"
                x2="58.32"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="158.02"
                y1="0.58"
                x2="158.02"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="257.72"
                y1="0.58"
                x2="257.72"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="357.42"
                y1="0.58"
                x2="357.42"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="108.17"
                y1="0.58"
                x2="108.17"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="207.87"
                y1="0.58"
                x2="207.87"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="307.57"
                y1="0.58"
                x2="307.57"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="407.27"
                y1="0.58"
                x2="407.27"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="457.12"
                y1="0.58"
                x2="457.12"
                y2="10.58"
            />
            <line
                class="percentStrip-3"
                x1="457.12"
                y1="86"
                x2="457.12"
                y2="96"
            />
        </g>
    </svg>
</ng-template>
